import React from "react";
import { GroupJobPostingListController } from "./controller";
import { GroupJobPostingListView } from "./view";
import { styles } from "./styles";

export class GroupJobPostingList extends React.Component {
  render() {
    const controller = new GroupJobPostingListController(this.props);

    return (
      <GroupJobPostingListView
        controller={controller}
        {...this.props}
        styles={styles}
      />
    );
  }
}
